import * as React from 'react';
import { SVGProps } from 'react';

const SvgNewTeam = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <rect x='0.5' y='0.5' width='23' height='23' rx='11.5' stroke='#ECECEC' />
    <g clipPath='url(#clip0_4388_32052)'>
      <rect
        x='16.1393'
        y='4.66602'
        width='1.06475'
        height='5.32373'
        fill='black'
      />
      <rect
        x='14.0098'
        y='7.75391'
        width='1.06475'
        height='5.32372'
        transform='rotate(-90 14.0098 7.75391)'
        fill='black'
      />
      <path
        d='M16.3791 19.5723H15.3143V18.5076C15.3138 18.0841 15.1454 17.6782 14.846 17.3787C14.5466 17.0793 14.1406 16.9109 13.7172 16.9104H11.5877C11.1643 16.9109 10.7583 17.0793 10.4589 17.3787C10.1595 17.6782 9.99105 18.0841 9.99059 18.5076V19.5723H8.92584V18.5076C8.92667 17.8019 9.20739 17.1253 9.7064 16.6263C10.2054 16.1272 10.882 15.8465 11.5877 15.8457H13.7172C14.4229 15.8465 15.0995 16.1272 15.5985 16.6263C16.0975 17.1253 16.3782 17.8019 16.3791 18.5076V19.5723Z'
        fill='black'
      />
      <path
        d='M12.6525 10.5228C12.9684 10.5228 13.2772 10.6164 13.5398 10.7919C13.8025 10.9674 14.0072 11.2168 14.1281 11.5087C14.2489 11.8005 14.2806 12.1216 14.219 12.4315C14.1573 12.7413 14.0052 13.0258 13.7819 13.2492C13.5585 13.4726 13.2739 13.6247 12.9641 13.6863C12.6543 13.7479 12.3332 13.7163 12.0413 13.5954C11.7495 13.4745 11.5001 13.2698 11.3246 13.0072C11.1491 12.7445 11.0554 12.4358 11.0554 12.1199C11.0554 11.6963 11.2237 11.2901 11.5232 10.9905C11.8227 10.691 12.2289 10.5228 12.6525 10.5228ZM12.6525 9.45801C12.1261 9.45801 11.6114 9.61412 11.1737 9.90661C10.7359 10.1991 10.3948 10.6148 10.1933 11.1012C9.99181 11.5876 9.9391 12.1228 10.0418 12.6392C10.1445 13.1555 10.398 13.6298 10.7703 14.0021C11.1426 14.3744 11.6169 14.6279 12.1332 14.7306C12.6496 14.8333 13.1848 14.7806 13.6712 14.5791C14.1576 14.3776 14.5733 14.0365 14.8658 13.5987C15.1583 13.161 15.3144 12.6463 15.3144 12.1199C15.3144 11.4139 15.0339 10.7368 14.5347 10.2377C14.0355 9.73845 13.3585 9.45801 12.6525 9.45801Z'
        fill='black'
      />
      <path
        d='M8.39323 11.0547H7.32849C6.62277 11.0555 5.9462 11.3362 5.44718 11.8352C4.94817 12.3343 4.66746 13.0108 4.66663 13.7166V15.846H5.73137V13.7166C5.73184 13.2931 5.90025 12.8872 6.19967 12.5877C6.49909 12.2883 6.90505 12.1199 7.32849 12.1194H8.39323V11.0547Z'
        fill='black'
      />
      <path
        d='M8.39331 5.73076C8.70919 5.73076 9.01797 5.82443 9.28062 5.99993C9.54326 6.17542 9.74797 6.42485 9.86885 6.71669C9.98973 7.00853 10.0214 7.32965 9.95974 7.63946C9.89811 7.94927 9.746 8.23385 9.52264 8.45722C9.29928 8.68058 9.0147 8.83269 8.70489 8.89431C8.39508 8.95594 8.07395 8.92431 7.78212 8.80343C7.49028 8.68255 7.24085 8.47784 7.06535 8.21519C6.88986 7.95255 6.79619 7.64376 6.79619 7.32788C6.79619 6.9043 6.96446 6.49807 7.26398 6.19855C7.56349 5.89903 7.96973 5.73076 8.39331 5.73076ZM8.39331 4.66602C7.86684 4.66602 7.3522 4.82213 6.91446 5.11462C6.47672 5.40711 6.13554 5.82284 5.93407 6.30923C5.7326 6.79562 5.67988 7.33083 5.78259 7.84719C5.8853 8.36354 6.13882 8.83784 6.51109 9.2101C6.88336 9.58237 7.35765 9.83589 7.874 9.9386C8.39035 10.0413 8.92557 9.9886 9.41196 9.78712C9.89835 9.58565 10.3141 9.24448 10.6066 8.80673C10.8991 8.36899 11.0552 7.85435 11.0552 7.32788C11.0552 6.62191 10.7747 5.94485 10.2755 5.44566C9.77633 4.94646 9.09928 4.66602 8.39331 4.66602Z'
        fill='black'
      />
    </g>
    <defs>
      <clipPath id='clip0_4388_32052'>
        <rect width='16' height='16' fill='white' transform='translate(4 4)' />
      </clipPath>
    </defs>
  </svg>
);

export default SvgNewTeam;
